module.exports = __webpack_public_path__ + "static/1-6d03f0f90ecbfba6a9bd3231e6c92db6.jpg";